export default function dateFormatter(date: string, withComma=true) {
  const dateObj = new Date(date);
  const month = dateObj.toLocaleString("default", { month: "short" });
  const day = dateObj.getDate();
  const year = dateObj.getFullYear();
  if(withComma)
    return `${month} ${day}, ${year}`;
  else 
    return `${month} ${day} ${year}`
}

export function dateFormatterWithTime(dateString: string, withComma=false) {
  if (!dateString) return "";
  const options: Intl.DateTimeFormatOptions = {
    month: "long",
    day: "numeric",
    year: "numeric", // Change this to "numeric" or "2-digit"
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    timeZoneName: "short",
  };
  const date = new Date(dateString);
  let formattedDate = new Intl.DateTimeFormat("en-IN", options).format(date);
  // Replace the first comma with a pipe
  
  formattedDate = formattedDate.replace(",", " ");
  // Remove the second comma and the space before AM/PM

  formattedDate =  withComma ? formattedDate.replace(" at", ",") : formattedDate.replace("at", " | ");
  return formattedDate;
}
